module.exports = __webpack_public_path__ + "static/media/crossBtn.cf2df544.svg";